import * as React from 'react';

export default class WaitBlock extends React.PureComponent {
    render() {
        return (
            <div className="waitBlock">
                <div className="blockUIText">
                    <p>
                        Загрузка, подождите, пожалуйста, ...
                </p>
                </div>
                <article>
                    <section className="pyramid">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </section>
                </article>
            </div>);
    }
}